import React, { useLayoutEffect } from 'react';
import { Backdrop, CircularProgress } from '@mui/material';
import { Route, useHistory, } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';

import { SetStoreState, GetStore } from '../redux/slices/store-slice';
import { SetAuthState } from '../redux/slices/auth-slice';

const PrivateRoute = ({
  component: Component,
  withLayout: Layout,
  ...rest
}) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const {
    token,
    storesCount,
    storeStatus,
    storeId,
    user,
    payLater,
    connectedStore
  } = useSelector((state) => state.auth);
  const { store } = useSelector((state) => state.store);

  const renderRoute = () => (
    <Route
      {...rest}
      render={(props) => <Component {...props} />}
    />
  );

  useLayoutEffect(() => {
    const path = location.pathname;
    if (!token || token === '') {
      history.push('/auth/sign-in');
      return;
    } else if (token && ['user', 'affiliate-manager'].includes(user.role)) {
      if (user?.role === 'affiliate-manager') {
        history.push('/affiliate-users');
      } else {
        if (!isEmpty(storeId)) {
          dispatch(SetStoreState({ field: 'storeId', value: storeId }));
          dispatch(GetStore({ storeId }))
        } else if (!isEmpty(connectedStore) && path !== '/auth/sp-api') {
          dispatch(GetStore({ storeId: connectedStore }))
          dispatch(SetStoreState({ field: 'storeId', value: connectedStore }));
          dispatch(SetAuthState({ field: 'storeId', value: connectedStore }));
        }

        if (window.location.search.includes('spapi_oauth_code')) {
          if(storeStatus !== 'Initial') {
            history.push('/auth/sp-api');
          }
        } else {
          if (payLater && path !== '/auth/sp-api') {
            history.push(path);
          } else {
            history.push('/auth/sp-api');
          }
        }
      }
    } else {
      history.push(path);
    }
  }, [token, storesCount]);

  return token ? (<Layout>{renderRoute()}</Layout>) : (
    <Backdrop open={true} style={{ zIndex: '9' }}>
      <CircularProgress color='inherit' />
    </Backdrop>
  );
};

export default PrivateRoute;
